export enum PubsubEnum {
  CLOSE_UNLOCKTOKEN_MODAL = 'CLOSE_UNLOCKTOKEN_MODAL',
  CLOSE_CANCELTOKEN_MODAL = 'CLOSE_CANCELTOKEN_MODAL',
  CHANGE_CONTRACT = "CHANGE_CONTRACT",
  CHANGE_PROFILE_IMAGE = 'CHANGE_PROFILE_IMAGE',
  TOAST = 'toast',
  GEOLOCATION_NOT_ALLOWED_EVENT = 'GEOLOCATION_NOT_ALLOWED_EVENT',
  CLOSE_INACTIVITY_MODALS = 'CLOSE_INACTIVITY_MODALS',
}
